import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ChangeAvatarComponent } from '@core/components/change-avatar/change-avatar.component';
import { ChangePasswordComponent } from '@core/components/change-password/change-password.component';
import { toLevel, User } from '@interfaces';
import { Subject } from 'rxjs';
@Component({
  selector: 'tab-general',
  templateUrl: './tab-general.component.html',
  styleUrls: ['./tab-general.component.scss']
})
export class TabGeneralComponent implements OnInit {
  @Input()
  userForm: FormGroup;

  @Input()
  user: User;

  @Input()
  currentUser: User;

  @Input()
  isViewMode: boolean;

  @Input()
  reloadPage: Subject<void> = new Subject<void>();

  currentUserLevel = 0;
  isUpdate = false;
  imageHover = false;
  isOnEditDialog = false;
  avatarImagePayload = null;
  hasUsersEditPermission = false;
  isNewUser = false;

  constructor(
    private materialDialog: MatDialog,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit(): void {
    this.hasUsersEditPermission = this.authenticationService.hasPermission('users-edit');
    this.isOnEditDialog = !!(this.user.id);
    this.currentUserLevel = toLevel(this.currentUser.role);
    this.user.authenticationInfo = this.user.authenticationInfo || {};
    this.user.authenticationInfo.status = this.user.authenticationInfo.status || 'UNKNOWN';
    this.user.authenticationInfo.enabled =
      typeof this.user.authenticationInfo.enabled === 'boolean'
        ? this.user.authenticationInfo.enabled
        : 'UNKNOWN';

        if (this.user['id']) {
          this.isNewUser = true;
        }
  }

  public openChangePasswordDialog(): void {
    this.materialDialog
      .open<any>(ChangePasswordComponent, {
        panelClass: 'change-password-dialog',
        autoFocus: true,
        data: this.user || null
      }).afterClosed().subscribe((value) => {
        if (value && value.password) {
          this.user['password'] = value.password;
        }
      });
  }

  public openChangeAvatarDialog(): void {
    this.materialDialog
      .open<any>(ChangeAvatarComponent, {
        panelClass: 'change-avatar-dialog',
        autoFocus: false,
        data: this.user.id || null
      }).afterClosed().subscribe((value) => {
        if (value && value.avatarImagePayload && value.avatarImagePayload.imageBase64Encoded) {
          this.avatarImagePayload = value.avatarImagePayload;
          this.user.avatarUrl = value.avatarImagePayload.imageBase64Encoded;

          if (this.isOnEditDialog) {
            this.reloadPage.next();
          }
        }
      });
  }
}
